import React from "react";
import { LinkAreaViewModel } from "../../../Model/Blocks/NotAvailableForEdit/LinkAreaViewModel.csharp";
import { NavigationLink } from "./NavigationLink";
import classNames from "classnames";

export const LinkArea: React.FC<LinkAreaViewModel> = ({ heading, links }) => {
  const isMobile = "ontouchstart" in window;
  return (
    <>
      <NavigationLink link={heading} className="link-list-section-heading-link" />
      {links.length != 0 && (
        <ul className="link-list link-list--bare-bones">
          {links.map((link, index) => (
            <li className="m-0" key={index}>
              <a className={classNames("d-inline-block", "no-underline", {"py-1": isMobile, "mb-1":!isMobile})} href={link.url}>{link.title}</a>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
